import React, { ReactNode } from 'react';
import styles from './styles.module.css';
import Button from '@/components/common/Button';
import { useLayoutContext } from '@/context/LayoutContext';
import PaymentButtons from './PaymentButtons';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import BannerCta from '@/components/general/BannerCta';
import { historyType } from '@/commonTypes';

export default function MyPlatesTotal({
  d,
  children,
  className = '',
  showGlow = true,
  data,
}: {
  d?: {
    label?: string;
    value?: string;
    note?: string;
    showDiscount?: boolean;
    title?: string;
  };
  children?: ReactNode;
  className?: string;
  showGlow?: boolean;
  data?: historyType;
}) {
  const { priceSymbol } = useLayoutContext();
  // let d = {
  //   label: 'مبلغ بدهی تمام پلاک‌های ثبت‌شدهٔ کاربر',
  //   value: '۸٬۰۰۰٬۰۰۰',
  //   note: 'شامل خلافی هر سه پلاک — قابل پرداخت یکجا با تخفیف',
  // };
  return (
    <BannerCta className={`${className}`} showGlow={showGlow}>
      <div className={`${styles.totalInfo} `}>
        {d?.title && <div className={styles.title}>{d?.title}</div>}
        <div className={styles.totalLabel}>{d?.label}</div>
        <div className={`${styles.priceContainer}`}>
          {d?.value && <PriceSection value={d?.value} className={styles.totalValue} />}
          {d?.showDiscount && <span className={`${styles.discount}`}>(۱۰٪ تخفیف پرداخت یکجا)</span>}
        </div>
        {d?.note && <div className={styles.totalNote}>{d?.note}</div>}
      </div>
      {children ? children : Number(d?.value) != 0 && <PaymentButtons />}
    </BannerCta>
  );
}
